module.exports = __webpack_public_path__ + "static/img/gold2.dd2eb8f0.png";